import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { AlertTriangleIcon } from 'lucide-react';

interface NoComparisonDataDialogProps {
  open: boolean;
  errorMessage?: string;
  onClose: () => void;
  onSendErrorReport: () => void;
}

function NoComparisonDataDialog({ open, onClose, onSendErrorReport }: NoComparisonDataDialogProps) {
  return (
    <Dialog open={open} maxWidth='xs' fullWidth>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '16px' }}>
          <AlertTriangleIcon size={24} color='#B45309' />
          <Typography variant='h6' sx={{ fontWeight: 700, color: '#92400E' }}>
            Warning: No Comparison Data
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: '#FFFBEB',
            border: '1px solid #FDE68A',
            borderRadius: '8px',
            padding: '16px',
          }}
        >
          <Typography variant='body2' sx={{ color: '#92400E' }}>
            The filters as specified result in no available data for comparison. As a result, the system is unable to
            generate reliable comparative insights at this time.
          </Typography>
          <br />
          <Typography variant='body2' sx={{ color: '#92400E' }}>
            Consider adjusting the filters to increase the amount of data available. If you believe that you are
            receiving this message in error, please submit an error report and we will investigate the root cause of the
            issue.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px', justifyContent: 'center', gap: '8px' }}>
        <Button variant='outlined' disableElevation onClick={onClose}>
          Continue to edit filters
        </Button>
        <Button variant='contained' disableElevation color='primary' onClick={onSendErrorReport}>
          Send Error Report
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NoComparisonDataDialog;
